import api from './api';

const applicationService = {
  // Récupérer toutes les candidatures de l'utilisateur connecté
  getMyApplications: async (params = {}) => {
    const queryParams = new URLSearchParams();
    
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
        queryParams.append(key, params[key]);
      }
    });

    const queryString = queryParams.toString();
    const url = queryString ? `/applications/my-applications?${queryString}` : '/applications/my-applications';
    
    return await api.get(url);
  },

  // Récupérer une candidature par ID
  getApplicationById: async (id) => {
    return await api.get(`/applications/${id}`);
  },

  // Créer une nouvelle candidature
  createApplication: async (applicationData) => {
    return await api.post('/applications', applicationData);
  },

  // Mettre à jour une candidature
  updateApplication: async (id, applicationData) => {
    return await api.put(`/applications/${id}`, applicationData);
  },

  // Supprimer une candidature
  deleteApplication: async (id) => {
    return await api.delete(`/applications/${id}`);
  },

  // Récupérer les candidatures pour une mission spécifique
  getApplicationsForMission: async (missionId) => {
    return await api.get(`/applications/mission/${missionId}`);
  },

  // Récupérer les statistiques des candidatures de l'utilisateur
  getMyApplicationStats: async () => {
    return await api.get('/applications/my-stats');
  }
  ,
  getApplicationsForMyMissions: async (params = {}) => {
    const queryParams = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
        queryParams.append(key, params[key]);
      }
    });
    const queryString = queryParams.toString();
    const url = queryString ? `/applications/my-missions?${queryString}` : '/applications/my-missions';
    return await api.get(url);
  }
};

export default applicationService;